import { render, staticRenderFns } from "./reg_third.vue?vue&type=template&id=5922b129&scoped=true"
import script from "./reg_third.vue?vue&type=script&lang=js"
export * from "./reg_third.vue?vue&type=script&lang=js"
import style0 from "./reg_third.vue?vue&type=style&index=0&id=5922b129&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5922b129",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5922b129')) {
      api.createRecord('5922b129', component.options)
    } else {
      api.reload('5922b129', component.options)
    }
    module.hot.accept("./reg_third.vue?vue&type=template&id=5922b129&scoped=true", function () {
      api.rerender('5922b129', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/landingpage/reg_third.vue"
export default component.exports